import React from 'react';
import { FormSubmitted } from '../GtmSubscription/Events/FormSubmitted';
import { MessageBroker } from '~/Features/Messaging/MessageBroker';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';
import type { BookMeetingFormProps } from './Components/BookMeetingForm/BookMeetingForm';
import { BookMeetingForm } from './Components/BookMeetingForm/BookMeetingForm';
import type { BookMeetingFormConfirmationProps } from './Components/BookMeetingFormConfirmation/BookMeetingFormConfirmation';
import { BookMeetingFormConfirmation } from './Components/BookMeetingFormConfirmation/BookMeetingFormConfirmation';

export interface BookMeetingOverlayContentProps
    extends StrictOmit<BookMeetingFormProps, 'heading' | 'onSubmitted'>,
        StrictOmit<BookMeetingFormConfirmationProps, 'heading' | 'onClick' | 'buttonLabel'> {
    formId: string;
    formHeading: string;
    confirmationHeading: string;
    confirmationButtonLabel: string;
    onClose: () => void;
}

export const BookMeetingOverlayContent: React.FC<React.PropsWithChildren<BookMeetingOverlayContentProps>> = props => {
    const { formHeading, confirmationHeading, confirmationButtonLabel, onClose, formId, ...restProps } = props;

    const [isSubmitted, setIsSubmitted] = React.useState(false);

    const handleSubmit = () => setIsSubmitted(true);

    React.useEffect(() => {
        if (isSubmitted) {
            MessageBroker.publish(new FormSubmitted(formId));
        }
    }, [isSubmitted]);

    if (isSubmitted) {
        return (
            <BookMeetingFormConfirmation
                {...restProps}
                heading={confirmationHeading}
                onClick={onClose}
                buttonLabel={confirmationButtonLabel}
            />
        );
    }

    return <BookMeetingForm {...restProps} heading={formHeading} onSubmitted={handleSubmit} />;
};
